<template>
    <div>
        <div ref="boxFixed" :class="{'is_fixed': isFixed, 'fix_in_top':fixedInTop}" >
            <slot>no content</slot>
        </div> 
    </div>   
</template>
<script>
import { onBeforeUnmount, onMounted, ref, watch,h } from "vue"


// 跳转到指定索引的元素
function scrollTo(targetOffsetTop) {
    // 获取当前 offsetTop
    let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    // 定义一次跳 50 个像素，数字越大跳得越快，但是会有掉帧得感觉，步子迈大了会扯到蛋
    const STEP = 200
    // 判断是往下滑还是往上滑
    if (scrollTop > targetOffsetTop) {
        // 往上滑
        smoothUp()
    } else {
        // 往下滑
        smoothDown()
    }
    // 定义往下滑函数
    function smoothDown() {
        // 如果当前 scrollTop 小于 targetOffsetTop 说明视口还没滑到指定位置
        if (scrollTop < targetOffsetTop) {
            // 如果和目标相差距离大于等于 STEP 就跳 STEP
            // 否则直接跳到目标点，目标是为了防止跳过了。
            if (targetOffsetTop - scrollTop >= STEP) {
                scrollTop += STEP
            } else {
                scrollTop = targetOffsetTop
            }
            document.body.scrollTop = scrollTop
            document.documentElement.scrollTop = scrollTop
            // 关于 requestAnimationFrame 可以自己查一下，在这种场景下，相比 setInterval 性价比更高
            requestAnimationFrame(smoothDown)
        }
    }
    // 定义往上滑函数
    function smoothUp() {
        if (scrollTop > targetOffsetTop) {
            if (scrollTop - targetOffsetTop >= STEP) {
                scrollTop -= STEP
            } else {
                scrollTop = targetOffsetTop
            }
            document.body.scrollTop = scrollTop
            document.documentElement.scrollTop = scrollTop
            requestAnimationFrame(smoothUp)
        }
    }
}
export default {
    name:'affix',
    $emits:['update:modelValue'],
    props:{modelValue:Number,anchorSelector:String},
    setup(props,{emit}){

        const boxFixed = ref(null)

        let isFixed=ref(true),
            fixedInTop=ref(false),
            tabOffsetTop=0,
            active=props.modelValue||0,
            scrolling=false
        // 所有锚点元素的 offsetTop
        const offsetTopArr = []

        function loadNavContents(){
                if(!offsetTopArr.length)    {
                    // 获取所有锚点元素
                    const navContents = document.querySelectorAll(props.anchorSelector)
                    if(navContents.length){
                        navContents.forEach(item => {
                            offsetTopArr.push(item.offsetTop)
                        })
                        if(navContents.length>1){
                            const lastContent = navContents[navContents.length-1]
                            const div = document.createElement('div')
                            div.setAttribute('style', 'height:500px')
                            lastContent.append(div)
                        }
                        
                    }
                    
                }
                
        }

        function handleScroll(){
            if(tabOffsetTop===0){
                
                let d = boxFixed.value
                if(d){
                    tabOffsetTop = d.offsetTop
                }                
            }else{  
                // 获取当前文档流的 scrollTop                      
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
                isFixed.value = scrollTop > tabOffsetTop ? true : false; // 如果滚动到顶部了，this.isFixed就为true  
                fixedInTop.value =  isFixed.value     
                //console.log('scrollTop:'+scrollTop+',tabOffsetTop:'+this.tabOffsetTop+',isFixed:'+this.isFixed)

                loadNavContents()
               
                // 定义当前点亮的导航下标
                let navIndex = 0
                for (let n = 0; n < offsetTopArr.length; n++) {
                    // 如果 scrollTop 大于等于第 n 个元素的 offsetTop 则说明 n-1 的内容已经完全不可见
                    // 那么此时导航索引就应该是 n 了
                    if (scrollTop >= offsetTopArr[n]) {
                        navIndex = n
                    }
                }
                // 把下标赋值给 vue 的 data
                if(!scrolling && active !== navIndex) {
                    active = navIndex
                    emit('update:modelValue', active)
                }
            }



        }

    
        
        onMounted(function(){            
            window.addEventListener('scroll',handleScroll)
            watch(
                ()=>props.modelValue,
                (newValue)=>{
                    
                    if(!scrolling && newValue!=active){  
                        loadNavContents()                      
                        active = newValue
                        scrolling = true
                        scrollTo(offsetTopArr[active])
                        scrolling = false
                    }
                }
            )
        })
        onBeforeUnmount(() => {
            window.removeEventListener('scroll',handleScroll)
        })

        return {isFixed, fixedInTop, boxFixed}
    }
}
</script>


<style scoped>
    .is_fixed{
        position: fixed;
        z-index: 999;
        width: 100%;
    }
    .fix_in_top{
        top:0px;
    }

</style>